import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { getApiBaseUrl } from "../api/client";
// import VIDEOSDK from "../components/VideoSDK";
import VideoCall from "../components/VideoCall";
import { useParams } from "react-router-dom";
import EMRPatientInfo from "../components/EMR_PatientInfo";
import EMRBedSide from "../components/EMR_BedSide";
import EMRTelestrokeExam from "../components/EMR_TelestrokeExam";
import QuadrantTracking from "../components/QuadrantTracking";
import StimulusVideoController from "../components/StimulusVideoController";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Line } from "react-chartjs-2";
import { submitExamData, submitTrackingSession } from "../utils/auth";
import Papa from "papaparse";
import AppShell from "../components/AppShell";

const EMRpage = () => {
  const { patientid, meetingid } = useParams();
  const [selectedEye, setSelectedEye] = useState(null);
  const [meetingJoined, setMeetingJoined] = useState(false);
  const [centerFocus, setCenterFocus] = useState(null);
  const [tab, setTab] = useState(0);
  const [settings, setSettings] = useState({
    eye_camera_control: "",
    exam_mode: "",
    stimulus_type: "",
    speed: "slow",
    stop: "",
    coordinates: "",
    shape: "",
  });
  const [examId, setExamId] = useState(null);
  const [currentSession, setCurrentSession] = useState(null);
  const [trackingSessions, setTrackingSessions] = useState([]);
  const [plottingEnabled, setPlottingEnabled] = useState(false);
  const [plottingData, setPlottingData] = useState({
    eyeX: [],
    eyeY: [],
    stimX: [],
    stimY: [],
    labels: [],
  });

  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Eye Coordinate X",
        borderColor: "#1e40af",
        backgroundColor: "#1e40af",
        fill: false,
        data: [],
        pointRadius: 0,
        tension: 0.3,
        spanGaps: true,
      },
      {
        label: "Stimulus X",
        borderColor: "#10b981",
        backgroundColor: "#10b981",
        fill: false,
        data: [],
        pointRadius: 0,
        tension: 0.3,
        spanGaps: true,
      },
      {
        label: "Eye Coordinate Y",
        borderColor: "#9d174d",
        backgroundColor: "#9d174d",
        fill: false,
        data: [],
        pointRadius: 0,
        tension: 0.3,
        spanGaps: true,
      },
      {
        label: "Stimulus Y",
        borderColor: "#f97316",
        backgroundColor: "#f97316",
        fill: false,
        data: [],
        pointRadius: 0,
        tension: 0.3,
        spanGaps: true,
      },
    ],
  });

  const chartRef = useRef(null);
  const MAX_POINTS = 1000;
  const csvDataLoaded = useRef(false);
  const stimulusXData = useRef([]);
  const stimulusYData = useRef([]);
  const currentDataIndex = useRef(0);
  const cumulativeData = useRef({
    labels: [],
    eyeX: [],
    eyeY: [],
    stimX: [],
    stimY: [],
  });
  const webSocketRef = useRef(null);
  const eyeDataBuffer = useRef([]);
  const sessionDataPoints = useRef([]);
  const lastValidEyeData = useRef({ eyeX: 0, eyeY: 0 });
  const SMOOTH_WINDOW = 5;
  const lastEyeTimestamp = useRef(null);
  const eyeTrackingStartTime = useRef(null);
  const stimulusStartTime = useRef(null);
  const sessionStarted = useRef(false);
  const pauseStartTime = useRef(null);
  const [calibrateCounts, setCalibrateCounts] = useState({ left: 0, right: 0 });

  // Pause state
  const [isPaused, setIsPaused] = useState(false);

  const centerFocusRef = useRef(centerFocus);
  useEffect(() => {
    centerFocusRef.current = centerFocus;
  }, [centerFocus]);

  const isPausedRef = useRef(isPaused);
  useEffect(() => {
    isPausedRef.current = isPaused;
  }, [isPaused]);

  const plottingEnabledRef = useRef(plottingEnabled);
  useEffect(() => {
    plottingEnabledRef.current = plottingEnabled;
  }, [plottingEnabled]);

  const currentSessionRef = useRef(currentSession);
  useEffect(() => {
    currentSessionRef.current = currentSession;
  }, [currentSession]);

  // Check if stimulus is active (both type and shape are selected)
  const isStimulusActive = useRef(false);

  // Stimulus interval ref
  const stimulusIntervalRef = useRef(null);

  // Track if WebSocket is already connected
  const webSocketConnected = useRef(false);

  // Track if stimulus data has been completely plotted
  const stimulusDataComplete = useRef(false);

  // Track if we need to save session on pause
  const shouldSaveOnPause = useRef(false);

  // Track if session was saved due to CSV completion
  const sessionSavedDueToCSVComplete = useRef(false);

  // Skip sending videoController-webhook when settings are reset automatically on completion
  const skipNextWebhookRef = useRef(false);

  // Track latest eye data for pairing with stimulus
  const latestEyeDataForStimulus = useRef({
    eyeX: null,
    eyeY: null,
    timestamp: null,
  });

  // Start session when stimulus becomes active
  useEffect(() => {
    isStimulusActive.current = !!(settings.stimulus_type && settings.shape && settings.speed);
    console.log("Stimulus active:", isStimulusActive.current, {
      stimulus_type: settings.stimulus_type,
      shape: settings.shape,
      speed: settings.speed,
    });

    // START SESSION WHEN STIMULUS BECOMES ACTIVE
    if (
      centerFocus &&
      isStimulusActive.current &&
      !currentSession &&
      !sessionStarted.current
    ) {
      console.log("Stimulus is ON - starting new session");
      startNewStimulusSession();
    }
  }, [settings.stimulus_type, settings.shape, settings.speed, centerFocus]);

  // Reset eye tracking start time and graph when meeting is joined or changed
  useEffect(() => {
    eyeTrackingStartTime.current = null;
    resetPlottingState();
  }, [meetingJoined, meetingid]);

  // Initialize WebSocket for eye data
  useEffect(() => {
    if (webSocketConnected.current) {
      return;
    }

    // webSocketRef.current = new WebSocket("ws://localhost:3001");
    // webSocketRef.current = new WebSocket("ws://35.154.32.201:3001");

    webSocketRef.current = new WebSocket("wss://telestrokeapp.duckdns.org/socket/");


    webSocketRef.current.onopen = () => {
      console.log("WebSocket connected for eye data");
      webSocketConnected.current = true;
    };

    webSocketRef.current.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log("eye data ", data);
        if (data.type === "eye_data") {
          const timestamp = data?.timestamp || Date.now();
          lastEyeTimestamp.current = timestamp;
          if (eyeTrackingStartTime.current == null) {
            eyeTrackingStartTime.current = timestamp;
          }

          const angle_x = data?.angle_x ?? lastValidEyeData.current.eyeX;
          const angle_y = data?.angle_y ?? lastValidEyeData.current.eyeY;

          // Always update last valid value
          if (angle_x != null && angle_y != null) {
            lastValidEyeData.current = { eyeX: angle_x, eyeY: angle_y };
            // Store latest eye data for pairing with stimulus
            latestEyeDataForStimulus.current = {
              eyeX: angle_x,
              eyeY: angle_y,
              timestamp: timestamp,
            };
          }

          // STOP processing when PAUSED or when NOT in Center Focus (e.g., in Quadrant mode)
          if (isPausedRef.current || !centerFocusRef.current) return;

          // Only continue if NOT paused and in Center Focus
          eyeDataBuffer.current.push({ angle_x, angle_y, timestamp });

          if (eyeDataBuffer.current.length > MAX_POINTS) {
            eyeDataBuffer.current.shift();
          }

          // ONLY plot eye data directly if in Center Focus and stimulus plotting IS NOT driving the graph
          if (centerFocusRef.current && (!plottingEnabledRef.current || isPausedRef.current)) {
            processAndPlotEyeData();
          }

          // Store eye-only data points when stimulus is active
          if (
            isStimulusActive.current &&
            currentSessionRef.current &&
            !stimulusDataComplete.current &&
            !isPausedRef.current
          ) {
            // Store eye-only data point (stimulus will be paired later)
            const dataPoint = {
              timestamp: new Date(timestamp),
              relativeTime:
                (timestamp - currentSessionRef.current.sessionStart.getTime()) / 1000,
              eyeX: angle_x,
              eyeY: angle_y,
              stimX: null, // Will be paired with stimulus data
              stimY: null, // Will be paired with stimulus data
              stimulusType: currentSessionRef.current.stimulusType,
              isPaired: false, // Not yet paired with stimulus
            };
            sessionDataPoints.current = [
              ...sessionDataPoints.current,
              dataPoint,
            ];
          }
        }
      } catch (err) {
        console.error("WebSocket parse error:", err);
      }
    };

    webSocketRef.current.onerror = (error) => {
      console.error("WebSocket error:", error);
      if (!webSocketConnected.current) {
        console.error("WebSocket connection error occurred.");
      }
    };

    webSocketRef.current.onclose = () => {
      console.log("WebSocket disconnected");
      webSocketConnected.current = false;
    };

    return () => {
      if (webSocketRef.current) {
        webSocketRef.current.close();
        webSocketConnected.current = false;
      }
    };
  }, []);

  const togglePause = () => {
    setIsPaused((prev) => {
      const newPaused = !prev;

      if (newPaused) {
        // Track when we paused to adjust stimulus start time on resume
        pauseStartTime.current = Date.now();

        // Stop eye data processing
        eyeDataBuffer.current = [];

        // Stop stimulus plotting interval
        if (stimulusIntervalRef.current) {
          clearInterval(stimulusIntervalRef.current);
          stimulusIntervalRef.current = null;
        }

        console.log("⛔ PAUSED: Eye + Stimulus plotting stopped");
      } else {
        // RESUMING: Adjust start times to account for pause duration
        if (pauseStartTime.current) {
          const pauseDuration = Date.now() - pauseStartTime.current;
          if (stimulusStartTime.current) {
            stimulusStartTime.current += pauseDuration;
          }
          if (eyeTrackingStartTime.current) {
            eyeTrackingStartTime.current += pauseDuration;
          }
          pauseStartTime.current = null;
          console.log(`Adjusted tracking start times by ${pauseDuration}ms`);
        }

        // Restart stimulus plotting when resuming
        if (!stimulusDataComplete.current && plottingEnabled) {
          startStimulusPlotting();
        }

        console.log("▶ RESUMED: Plotting restarted");
      }

      return newPaused;
    });
  };

  // Process and plot eye data
  const processAndPlotEyeData = () => {
    if (eyeDataBuffer.current.length === 0 || isPausedRef.current || !centerFocusRef.current) return;

    let newEyeX = null;
    let newEyeY = null;

    // Relative time label for continuity (starting from 0 seconds for each meeting)
    const currentTs = lastEyeTimestamp.current || Date.now();
    if (eyeTrackingStartTime.current == null) {
      eyeTrackingStartTime.current = currentTs;
    }
    const elapsedSec = (currentTs - eyeTrackingStartTime.current) / 1000;

    let newLabel = stimulusStartTime.current
      ? parseFloat(((Date.now() - stimulusStartTime.current) / 1000).toFixed(2))
      : parseFloat(elapsedSec.toFixed(2));

    // Smooth for plotting only
    if (eyeDataBuffer.current.length >= SMOOTH_WINDOW) {
      const window = eyeDataBuffer.current.slice(-SMOOTH_WINDOW);
      newEyeX = window.reduce((sum, p) => sum + p.angle_x, 0) / SMOOTH_WINDOW;
      newEyeY = window.reduce((sum, p) => sum + p.angle_y, 0) / SMOOTH_WINDOW;
    } else {
      const latest = eyeDataBuffer.current[eyeDataBuffer.current.length - 1];
      newEyeX = latest.angle_x;
      newEyeY = latest.angle_y;
    }

    if (newEyeX != null && newEyeY != null) {
      lastValidEyeData.current = { eyeX: newEyeX, eyeY: newEyeY };
    }

    // Capture latest stimulus data to keep arrays synchronized
    const currentStimX = (plottingEnabled && !stimulusDataComplete.current && currentDataIndex.current < plottingData.stimX.length)
      ? (plottingData.stimX[currentDataIndex.current] || null)
      : null;
    const currentStimY = (plottingEnabled && !stimulusDataComplete.current && currentDataIndex.current < plottingData.stimY.length)
      ? (plottingData.stimY[currentDataIndex.current] || null)
      : null;

    // Update cumulative data for plotting
    cumulativeData.current = {
      ...cumulativeData.current,
      labels: [...cumulativeData.current.labels, newLabel],
      eyeX: [...cumulativeData.current.eyeX, newEyeX],
      eyeY: [...cumulativeData.current.eyeY, newEyeY],
      stimX: [...cumulativeData.current.stimX, currentStimX],
      stimY: [...cumulativeData.current.stimY, currentStimY],
    };

    // Trim cumulative data (ALWAYS shift all arrays to keep them in sync)
    if (cumulativeData.current.labels.length > MAX_POINTS) {
      cumulativeData.current.labels.shift();
      cumulativeData.current.eyeX.shift();
      cumulativeData.current.eyeY.shift();
      cumulativeData.current.stimX.shift();
      cumulativeData.current.stimY.shift();
    }

    // Update chart data
    setChartData((prev) => ({
      ...prev,
      labels: cumulativeData.current.labels,
      datasets: [
        { ...prev.datasets[0], data: cumulativeData.current.eyeX },
        { ...prev.datasets[1], data: cumulativeData.current.stimX },
        { ...prev.datasets[2], data: cumulativeData.current.eyeY },
        { ...prev.datasets[3], data: cumulativeData.current.stimY },
      ],
    }));
  };


  // Reset stimulus plotting state
  const resetPlottingState = () => {
    console.log("Resetting stimulus plotting state");

    // Clear all cumulative data to ensure graph starts from the beginning
    cumulativeData.current = {
      labels: [],
      eyeX: [],
      eyeY: [],
      stimX: [],
      stimY: [],
    };

    // Reset chart data state immediately to clear the UI
    setChartData((prev) => ({
      ...prev,
      labels: [],
      datasets: prev.datasets.map(dataset => ({
        ...dataset,
        data: []
      }))
    }));

    setPlottingData((prev) => ({
      ...prev,
      stimX: [],
      stimY: [],
    }));

    eyeDataBuffer.current = [];
    stimulusXData.current = [];
    stimulusYData.current = [];
    currentDataIndex.current = 0;
    csvDataLoaded.current = false;
    stimulusStartTime.current = null;
    eyeTrackingStartTime.current = null;
    stimulusDataComplete.current = false;
    sessionSavedDueToCSVComplete.current = false;
  };

  // Save current session
  const saveCurrentSession = async (keepOpen = false) => {
    if (!currentSession || sessionDataPoints.current.length === 0) {
      console.log("No session or data points to save.");
      return;
    }

    // Only save stimulus sessions if they are fully completed
    if (isStimulusActive.current && !stimulusDataComplete.current) {
      console.log("Stimulus session not complete - as per user request, skipping save.");
      return;
    }

    // Filter to only include data points that have at least eye OR stimulus data
    const validDataPoints = sessionDataPoints.current.filter(
      (dp) =>
        dp.eyeX != null ||
        dp.eyeY != null ||
        dp.stimX != null ||
        dp.stimY != null
    );

    if (validDataPoints.length === 0) {
      console.log("No valid data points to save.");
      return;
    }

    // Calculate statistics
    const pairedDataPoints = validDataPoints.filter((dp) => dp.isPaired);
    const eyeOnlyPoints = validDataPoints.filter(
      (dp) => !dp.isPaired && (dp.eyeX != null || dp.eyeY != null)
    );
    const stimulusOnlyPoints = validDataPoints.filter(
      (dp) => !dp.isPaired && (dp.stimX != null || dp.stimY != null)
    );

    const sessionToSave = {
      ...currentSession,
      sessionEnd: new Date(),
      dataPoints: validDataPoints,
      // Enhanced statistics
      stats: {
        totalDataPoints: validDataPoints.length,
        pairedDataPoints: pairedDataPoints.length,
        eyeOnlyPoints: eyeOnlyPoints.length,
        stimulusOnlyPoints: stimulusOnlyPoints.length,
        durationSeconds: (new Date() - currentSession.sessionStart) / 1000,
        stimulusType: currentSession.stimulusType,
        stimulusShape: currentSession.stimulusShape,
        dataCompleteness: pairedDataPoints.length > 0 ? "Paired" : "Partial",
      },
    };

    const payloadSize = JSON.stringify(sessionToSave).length / 1024;
    console.log(
      `Saving session with ${validDataPoints.length} data points (${pairedDataPoints.length
      } paired), size: ${payloadSize.toFixed(2)} KB`
    );

    try {
      if (examId) {
        const response = await submitTrackingSession(examId, sessionToSave);
        if (response.error) {
          throw new Error(response.error);
        }
        setTrackingSessions((prev) => [...prev, sessionToSave]);
        toast.success("Tracking session saved successfully!");
      } else {
        setTrackingSessions((prev) => [...prev, sessionToSave]);
        toast.success("Tracking session saved locally!");
      }

      if (!keepOpen) {
        // Reset session state
        setCurrentSession(null);
        currentSessionRef.current = null;
        sessionDataPoints.current = [];
        sessionStarted.current = false;

        // Clear chart data if not keeping open
        if (!keepOpen) {
          cumulativeData.current = {
            labels: [],
            eyeX: [],
            eyeY: [],
            stimX: [],
            stimY: [],
          };
          setChartData((prev) => ({
            ...prev,
            labels: [],
            datasets: [
              { ...prev.datasets[0], data: [] },
              { ...prev.datasets[1], data: [] },
              { ...prev.datasets[2], data: [] },
              { ...prev.datasets[3], data: [] },
            ],
          }));
        }
      } else {
        // Only clear data points, keep session metadata
        sessionDataPoints.current = [];
      }
    } catch (error) {
      console.error("Error saving tracking session:", error);
      toast.error("Failed to save tracking session.");
    }
  };

  // Start new session for stimulus
  const startNewStimulusSession = (resetGraph = true) => {
    if (
      settings.exam_mode === "CenterFocus" &&
      settings.shape &&
      settings.stimulus_type &&
      selectedEye &&
      settings.speed
    ) {
      const newSession = {
        sessionStart: new Date(),
        selectedEye: selectedEye.toLowerCase(),
        stimulusType: settings.stimulus_type,
        stimulusShape: settings.shape,
        speed: settings.speed,
        examMode: settings.exam_mode,
        settingsHistory: [
          {
            stimulusType: settings.stimulus_type,
            stimulusShape: settings.shape,
            speed: settings.speed,
            examMode: settings.exam_mode,
            timestamp: new Date(),
          },
        ],
        dataPoints: [],
      };
      setCurrentSession(newSession);
      currentSessionRef.current = newSession;
      sessionDataPoints.current = [];
      sessionStarted.current = true;
      stimulusDataComplete.current = false;
      sessionSavedDueToCSVComplete.current = false;
      console.log("Started new stimulus session:", newSession);

      // Load CSV data for the stimulus
      if (resetGraph) {
        loadCSVData(settings.shape, settings.stimulus_type);
      }
    } else {
      console.log("Cannot start session - missing required settings:", {
        shape: settings.shape,
        stimulus_type: settings.stimulus_type,
        speed: settings.speed,
        selectedEye,
        exam_mode: settings.exam_mode,
      });
    }
  };

  // Handle settings changes
  useEffect(() => {
    if (
      centerFocus &&
      settings.shape &&
      settings.stimulus_type &&
      selectedEye &&
      settings.exam_mode === "CenterFocus"
    ) {
      if (
        !currentSession ||
        currentSession.stimulusType !== settings.stimulus_type ||
        currentSession.stimulusShape !== settings.shape ||
        currentSession.speed !== settings.speed
      ) {
        // Save existing session if it has data AND is complete
        if (
          currentSession &&
          sessionDataPoints.current.length > 0 &&
          !sessionSavedDueToCSVComplete.current &&
          (!isStimulusActive.current || stimulusDataComplete.current)
        ) {
          saveCurrentSession(false).then(() => {
            resetPlottingState();
            startNewStimulusSession();
          });
        } else {
          // If not complete, we just reset and start new without saving old one
          if (currentSession && !sessionSavedDueToCSVComplete.current) {
            console.log("Discarding incomplete stimulus session");
          }
          resetPlottingState();
          startNewStimulusSession();
        }
      }
    } else {
      // If stimulus settings are cleared or not in Center Focus, save any active session ONLY if complete
      if (
        currentSession &&
        sessionDataPoints.current.length > 0 &&
        !sessionSavedDueToCSVComplete.current &&
        (!isStimulusActive.current || stimulusDataComplete.current)
      ) {
        saveCurrentSession(false);
      } else if (currentSession && !sessionSavedDueToCSVComplete.current) {
        console.log("Discarding incomplete stimulus session on settings clear");
      }
      setCurrentSession(null);
      currentSessionRef.current = null;
      sessionStarted.current = false;
      sessionDataPoints.current = [];
      stimulusDataComplete.current = false;
    }
  }, [centerFocus, settings.shape, settings.stimulus_type, selectedEye, settings.exam_mode, settings.speed]);

  // Process stimulus data - PAIR WITH EYE DATA
  const startStimulusPlotting = () => {
    if (
      !plottingEnabled ||
      !currentSession ||
      isPaused ||
      stimulusDataComplete.current
    ) {
      console.log("Plotting not started - conditions not met");
      return;
    }

    // Clear any existing interval
    if (stimulusIntervalRef.current) {
      clearInterval(stimulusIntervalRef.current);
    }

    const TICK_INTERVAL = 10; // High frequency for smooth plotting

    console.log(
      `Starting stimulus plotting with ${stimulusXData.current.length} points, starting from index: ${currentDataIndex.current}`
    );

    stimulusIntervalRef.current = setInterval(() => {
      if (isPausedRef.current || !plottingEnabledRef.current || !currentSessionRef.current || stimulusDataComplete.current || !centerFocusRef.current) return;

      if (!stimulusStartTime.current) {
        stimulusStartTime.current = Date.now();
      }

      const elapsedTime = (Date.now() - stimulusStartTime.current) / 1000;
      let pointsProcessed = 0;

      // Process all points that should have occurred by now according to CSV time
      while (
        currentDataIndex.current < stimulusXData.current.length &&
        stimulusXData.current[currentDataIndex.current].time <= elapsedTime
      ) {
        const stimulusIndex = currentDataIndex.current;
        const newStimX = stimulusXData.current[stimulusIndex].value;
        const newStimY = stimulusYData.current[stimulusIndex].value;
        const stimulusTime = parseFloat(Number(stimulusXData.current[stimulusIndex].time).toFixed(2));

        // Update cumulative data for plotting
        cumulativeData.current = {
          ...cumulativeData.current,
          labels: [...cumulativeData.current.labels, stimulusTime],
          eyeX: [...cumulativeData.current.eyeX, lastValidEyeData.current.eyeX],
          eyeY: [...cumulativeData.current.eyeY, lastValidEyeData.current.eyeY],
          stimX: [...cumulativeData.current.stimX, newStimX],
          stimY: [...cumulativeData.current.stimY, newStimY],
        };

        // **PAIR STIMULUS DATA WITH EYE DATA**
        if (isStimulusActive.current && !isPaused && currentSession) {
          const {
            eyeX,
            eyeY,
            timestamp: eyeTimestamp,
          } = latestEyeDataForStimulus.current;

          const dataPoint = {
            timestamp: new Date(stimulusTime),
            relativeTime: stimulusXData.current[stimulusIndex].time,
            eyeX: eyeX,
            eyeY: eyeY,
            stimX: newStimX,
            stimY: newStimY,
            stimulusType: currentSession.stimulusType,
            isPaired: true,
            eyeTimestamp: eyeTimestamp,
          };

          sessionDataPoints.current = [
            ...sessionDataPoints.current,
            dataPoint,
          ];
        }

        currentDataIndex.current++;
        pointsProcessed++;

        // Trim data to maintain performance
        if (cumulativeData.current.labels.length > MAX_POINTS) {
          cumulativeData.current.labels.shift();
          cumulativeData.current.eyeX.shift();
          cumulativeData.current.eyeY.shift();
          cumulativeData.current.stimX.shift();
          cumulativeData.current.stimY.shift();
        }
      }

      if (pointsProcessed > 0) {
        // Update chart data
        setChartData((prev) => ({
          ...prev,
          labels: cumulativeData.current.labels,
          datasets: [
            { ...prev.datasets[0], data: cumulativeData.current.eyeX },
            { ...prev.datasets[1], data: cumulativeData.current.stimX },
            { ...prev.datasets[2], data: cumulativeData.current.eyeY },
            { ...prev.datasets[3], data: cumulativeData.current.stimY },
          ],
        }));
      }

      // Check for completion
      if (currentDataIndex.current >= stimulusXData.current.length) {
        console.log("Stimulus data plotting completed - all points processed");
        stimulusDataComplete.current = true;
        sessionSavedDueToCSVComplete.current = true;
        stopStimulusPlotting();
        setPlottingEnabled(false);

        if (currentSession && sessionDataPoints.current.length > 0) {
          saveCurrentSession(false);
        }

        // Reset settings to restart UI selection without sending extra webhook to server
        skipNextWebhookRef.current = true;
        setSettings((prev) => ({
          ...prev,
          stimulus_type: "",
          shape: "",
        }));
      }
    }, TICK_INTERVAL);
  };

  // Stop stimulus plotting
  const stopStimulusPlotting = () => {
    if (stimulusIntervalRef.current) {
      clearInterval(stimulusIntervalRef.current);
      stimulusIntervalRef.current = null;
      console.log("Stimulus plotting stopped");
    }
  };

  // Effect to handle pause/resume of stimulus plotting
  useEffect(() => {
    if (plottingEnabled && !isPaused && !stimulusDataComplete.current) {
      console.log("Starting/resuming stimulus plotting");
      startStimulusPlotting();
    } else {
      console.log("Stopping/pausing stimulus plotting");
      stopStimulusPlotting();
    }

    return () => {
      stopStimulusPlotting();
    };
  }, [plottingEnabled, isPaused, currentSession, plottingData]);

  // Check plotting conditions for stimulus
  useEffect(() => {
    const shouldPlotStimulus =
      centerFocus &&
      settings.stimulus_type &&
      settings.shape &&
      csvDataLoaded.current &&
      selectedEye &&
      !isPaused &&
      !stimulusDataComplete.current;

    console.log("Stimulus plotting conditions:", {
      centerFocus,
      stimulus_type: settings.stimulus_type,
      shape: settings.shape,
      csvDataLoaded: csvDataLoaded.current,
      eyeSelected: !!selectedEye,
      isPaused,
      stimulusDataComplete: stimulusDataComplete.current,
      shouldPlotStimulus,
      currentDataIndex: currentDataIndex.current,
      plottingDataLength: plottingData.stimX.length,
      currentSession: !!currentSession,
    });

    setPlottingEnabled(shouldPlotStimulus);

    if (!shouldPlotStimulus) {
      stopStimulusPlotting();
      if (isPaused) {
        console.log("Paused at stimulus index:", currentDataIndex.current);
      }
    } else {
      stimulusStartTime.current = Date.now();
      console.log(
        "Stimulus plotting enabled, starting from index:",
        currentDataIndex.current,
        "with",
        plottingData.stimX.length,
        "total points"
      );
    }
  }, [
    centerFocus,
    settings.stimulus_type,
    settings.shape,
    csvDataLoaded.current,
    selectedEye,
    isPaused,
    stimulusDataComplete.current,
  ]);

  // Load CSV data for stimulus
  const loadCSVData = async (shape, stimulusType) => {
    try {
      const speed = settings.speed || "slow";
      console.log(
        `Loading CSV data for shape: ${shape}, stimulus_type: ${stimulusType}, speed: ${speed}`
      );

      // Reset stimulus state when loading new CSV data
      resetPlottingState();

      let csvPath = "";
      if (stimulusType === "1") {
        // H-Shape
        csvPath = `/ShapesGraph/H-Shape/H_shape_${speed}.csv`;
      } else if (stimulusType === "3") {
        // Horizontal
        csvPath = `/ShapesGraph/Horizontal-Shape/Horizontal_${speed}.csv`;
      } else if (stimulusType === "2") {
        // Vertical
        csvPath = `/ShapesGraph/Vertical-Shape/Vertical_${speed}.csv`;
      } else {
        console.warn(`No CSV path defined for stimulus type: ${stimulusType}`);
        return;
      }

      const response = await fetch(csvPath);
      if (!response.ok) {
        throw new Error(`Failed to fetch CSV file: ${csvPath} (${response.status})`);
      }

      const csvText = await response.text();

      if (!centerFocusRef.current) {
        console.log("Navigated away from Center Focus during CSV load, ignoring data");
        return;
      }
      const parsed = Papa.parse(csvText, { header: true, skipEmptyLines: true });

      const xData = parsed.data
        .map((row) => {
          const timeValue = row["Time(s)"] || row["Time (s)"] || row["Time"] || row["time"] || 0;
          const xValue = row["X"] || row["X Position (pixels)"] || row["X Position"] || row["x"] || 0;
          return {
            time: parseFloat(parseFloat(timeValue).toFixed(2)) || 0,
            value: parseFloat(xValue) || 0,
          };
        })
        .filter((item) => !isNaN(item.time) && !isNaN(item.value));

      const yData = parsed.data
        .map((row) => {
          const timeValue = row["Time(s)"] || row["Time (s)"] || row["Time"] || row["time"] || 0;
          const yValue = row["Y"] || row["Y Position (pixels)"] || row["Y Position"] || row["y"] || 0;
          return {
            time: parseFloat(parseFloat(timeValue).toFixed(2)) || 0,
            value: parseFloat(yValue) || 0,
          };
        })
        .filter((item) => !isNaN(item.time) && !isNaN(item.value));

      if (xData.length === 0 || yData.length === 0) {
        throw new Error("Parsed CSV data is empty");
      }

      xData.sort((a, b) => a.time - b.time);
      yData.sort((a, b) => a.time - b.time);

      const limitedXData = xData.slice(0, MAX_POINTS);
      const limitedYData = yData.slice(0, MAX_POINTS);

      stimulusXData.current = limitedXData;
      stimulusYData.current = limitedYData;

      setPlottingData((prev) => ({
        ...prev,
        stimX: limitedXData.map((d) => d.value),
        stimY: limitedYData.map((d) => d.value),
        labels: limitedXData.map((d) => parseFloat(d.time.toFixed(2))),
      }));

      csvDataLoaded.current = true;
      stimulusDataComplete.current = false;
      sessionSavedDueToCSVComplete.current = false;
      console.log(
        `CSV data loaded successfully for shape: ${shape}, stimulus_type: ${stimulusType}`,
        {
          xDataLength: limitedXData.length,
          yDataLength: limitedYData.length,
          estimatedTime: (limitedXData.length / 4) * 0.005,
        }
      );
    } catch (error) {
      console.error("Error fetching or parsing CSV files:", error);
      toast.error("Error loading stimulus data from CSV files.");
      csvDataLoaded.current = false;
      stimulusDataComplete.current = false;
    }
  };

  const handleExamModeChange = (mode) => {
    if (mode === "Quadrant") {
      stopStimulusPlotting();
      setPlottingEnabled(false);
      plottingEnabledRef.current = false;
      isStimulusActive.current = false;
      sessionStarted.current = false;
      sessionDataPoints.current = [];
      setCurrentSession(null);
      currentSessionRef.current = null;
      stimulusDataComplete.current = false;

      // Clear the graph completely when in Quadrant
      resetPlottingState();

      centerFocusRef.current = false;
      setCenterFocus(false);
      setSettings((prev) => ({
        ...prev,
        exam_mode: "Quadrant",
        stimulus_type: "",
        shape: "",
        coordinates: null,
      }));
    } else if (mode === "CenterFocus") {
      stopStimulusPlotting();
      setPlottingEnabled(false);
      plottingEnabledRef.current = false;
      isStimulusActive.current = false;
      sessionStarted.current = false;
      sessionDataPoints.current = [];
      setCurrentSession(null);
      currentSessionRef.current = null;
      stimulusDataComplete.current = false;

      // Reset the graph when switching to Center Focus
      resetPlottingState();

      centerFocusRef.current = true;
      setCenterFocus(true);
      setSettings((prev) => ({
        ...prev,
        exam_mode: "CenterFocus",
        stimulus_type: "",
        shape: "",
        coordinates: null,
      }));
    }
  };

  // Ensure graph is cleared when centerFocus is false
  useEffect(() => {
    if (centerFocus === false) {
      stopStimulusPlotting();
      resetPlottingState();
    }
  }, [centerFocus]);

  const updateSetting = (key, value) => {
    console.log(`Updating setting: ${key} = ${value}`);
    if (key === "exam_mode") {
      if (value === "Quadrant") {
        handleExamModeChange("Quadrant");
        return;
      } else if (value === "CenterFocus") {
        handleExamModeChange("CenterFocus");
        return;
      }
    }
    setSettings((prevSettings) => ({ ...prevSettings, [key]: value }));
  };

  const handleCalibrate = () => {
    if (selectedEye && calibrateCounts[selectedEye] < 2) {
      const newCount = calibrateCounts[selectedEye] + 1;
      updateSetting("calibrate", { eye: selectedEye, count: newCount });
      setCalibrateCounts((prev) => ({ ...prev, [selectedEye]: newCount }));
      toast.success(`Calibration sent for ${selectedEye} eye (${newCount}/2)`);
    } else if (calibrateCounts[selectedEye] >= 2) {
      toast.warning(`Calibration limit reached for ${selectedEye} eye`);
    }
  };

  const handleResetCalibration = () => {
    if (selectedEye) {
      setCalibrateCounts((prev) => ({ ...prev, [selectedEye]: 0 }));
      // Send reset command to server
      updateSetting("calibrate", { eye: selectedEye, count: 0 });
      toast.success(`Calibration reset for ${selectedEye} eye`);
    }
  };

  // Lock eye switching once calibration has started for the selected eye
  const isEyeLocked =
    !!selectedEye && calibrateCounts[selectedEye] > 0;

  const handleEyeSelect = (eye) => {
    if (isEyeLocked && selectedEye !== eye) {
      toast.info("Reset calibration first before switching eyes.");
      return false;
    }
    setSelectedEye(eye);
    updateSetting("eye_camera_control", eye);
    return true;
  };

  const handleSave = async () => {
    try {
      // Save any active session first
      if (
        currentSession &&
        sessionDataPoints.current.length > 0 &&
        !sessionSavedDueToCSVComplete.current
      ) {
        await saveCurrentSession(false);
      }

      const patientEMR = JSON.parse(localStorage.getItem("patientEMR")) || {};
      
      // Age validation: at least 5 years between DOB and Exam Date
      if (patientEMR.PatientDOB && patientEMR.ExamDate) {
        const dob = new Date(patientEMR.PatientDOB);
        const exam = new Date(patientEMR.ExamDate);
        let ageAtExam = exam.getFullYear() - dob.getFullYear();
        const monthDiff = exam.getMonth() - dob.getMonth();
        const dayDiff = exam.getDate() - dob.getDate();
        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
          ageAtExam--;
        }
        if (ageAtExam < 5) {
          toast.error("Patient must be at least 5 years old on the exam date (Patient Info tab).");
          return;
        }
      }

      // Presence validation for mandatory fields
      if (!patientEMR.Name || !patientEMR.Doctor || !patientEMR.ExamDate) {
        toast.error("Mandatory fields missing: Name, Doctor, and Exam Date are required (Patient Info tab).");
        return;
      }

      const emrBedSideData =
        JSON.parse(localStorage.getItem("emrBedSideData")) || {};
      const emrTelestrokeExam =
        JSON.parse(localStorage.getItem("emrTelestrokeExam")) || {};

      const patientData = {
        patientid: patientid,
        Name: patientEMR.Name,
        Doctor: patientEMR.Doctor,
        patientDOB: patientEMR.PatientDOB,
        patientSex: patientEMR.PatientSex,
        examDate: patientEMR.ExamDate,
        visualActivityOD: patientEMR.VisualActivityOD,
        visualActivityOS: patientEMR.VisualActivityOS,
        neuroFindings: patientEMR.RelNeurologicalFinds,
        hasAphasia: patientEMR.HasAphasia ? "Yes" : "No",
        aphasiaDescription: patientEMR.AphasiaText || null,
      };

      const bedsideExamData = {
        smoothPursuitAndSaccadesResult:
          emrBedSideData.smoothPursuitAndSaccadesResult,
        smoothPursuitAndSaccadesDescription:
          emrBedSideData.smoothPursuitAndSaccadesDescription,
        hasNystagmus: emrBedSideData.hasNystagmus ? "Yes" : "No",
        gazeType: emrBedSideData.gazeType,
        visualFieldsODRUQ:
          emrBedSideData.od?.ruq === "pass"
            ? "Pass"
            : emrBedSideData.od?.ruq
              ? "Fail"
              : null,
        visualFieldsODRLQ:
          emrBedSideData.od?.rlq === "pass"
            ? "Pass"
            : emrBedSideData.od?.rlq
              ? "Fail"
              : null,
        visualFieldsODLUQ:
          emrBedSideData.od?.luq === "pass"
            ? "Pass"
            : emrBedSideData.od?.luq
              ? "Fail"
              : null,
        visualFieldsODLLQ:
          emrBedSideData.od?.llq === "pass"
            ? "Pass"
            : emrBedSideData.od?.llq
              ? "Fail"
              : null,
        extraocularMovementResult: emrBedSideData.extraocularMovementResult,
        extraocularMovementDescription:
          emrBedSideData.extraocularMovementDescription,
        nystagmusDegree: emrBedSideData.nystagmusDegree,
        examTolerated: emrBedSideData.examTolerated ? "Yes" : "No",
        visualFieldsOSRUQ:
          emrBedSideData.os?.ruq === "pass"
            ? "Pass"
            : emrBedSideData.os?.ruq
              ? "Fail"
              : null,
        visualFieldsOSRLQ:
          emrBedSideData.os?.rlq === "pass"
            ? "Pass"
            : emrBedSideData.os?.rlq
              ? "Fail"
              : null,
        visualFieldsOSLUQ:
          emrBedSideData.os?.luq === "pass"
            ? "Pass"
            : emrBedSideData.os?.luq
              ? "Fail"
              : null,
        visualFieldsOSLLQ:
          emrBedSideData.os?.llq === "pass"
            ? "Pass"
            : emrBedSideData.os?.llq
              ? "Fail"
              : null,
      };

      const teleStrokeExamData = {
        tele_smoothPursuitAndSaccadesResult:
          emrTelestrokeExam.smoothPursuitAndSaccadesResult,
        tele_smoothPursuitAndSaccadesDescription:
          emrTelestrokeExam.smoothPursuitAndSaccadesDescription,
        tele_hasNystagmus: emrTelestrokeExam.hasNystagmus ? "Yes" : "No",
        tele_gazeType: emrTelestrokeExam.gazeType,
        tele_visualFieldsODRUQ:
          emrTelestrokeExam.od?.ruq === "pass"
            ? "Pass"
            : emrTelestrokeExam.od?.ruq
              ? "Fail"
              : null,
        tele_visualFieldsODRLQ:
          emrTelestrokeExam.od?.rlq === "pass"
            ? "Pass"
            : emrTelestrokeExam.od?.rlq
              ? "Fail"
              : null,
        tele_visualFieldsODLUQ:
          emrTelestrokeExam.od?.luq === "pass"
            ? "Pass"
            : emrTelestrokeExam.od?.luq
              ? "Fail"
              : null,
        tele_visualFieldsODLLQ:
          emrTelestrokeExam.od?.llq === "pass"
            ? "Pass"
            : emrTelestrokeExam.od?.llq
              ? "Fail"
              : null,
        tele_extraocularMovementResult:
          emrTelestrokeExam.extraocularMovementResult,
        tele_extraocularMovementDescription:
          emrTelestrokeExam.extraocularMovementDescription,
        tele_nystagmusDegree: emrTelestrokeExam.nystagmusDegree,
        tele_examTolerated: emrTelestrokeExam.examTolerated ? "Yes" : "No",
        tele_visualFieldsOSRUQ:
          emrTelestrokeExam.os?.ruq === "pass"
            ? "Pass"
            : emrTelestrokeExam.os?.ruq
              ? "Fail"
              : null,
        tele_visualFieldsOSRLQ:
          emrTelestrokeExam.os?.rlq === "pass"
            ? "Pass"
            : emrTelestrokeExam.os?.rlq
              ? "Fail"
              : null,
        tele_visualFieldsOSLUQ:
          emrTelestrokeExam.os?.luq === "pass"
            ? "Pass"
            : emrTelestrokeExam.os?.luq
              ? "Fail"
              : null,
        tele_visualFieldsOSLLQ:
          emrTelestrokeExam.os?.llq === "pass"
            ? "Pass"
            : emrTelestrokeExam.os?.llq
              ? "Fail"
              : null,
      };

      const dataToSend = {
        patientData,
        bedsideExamData,
        teleStrokeExamData,
        trackingSessions,
      };

      const payloadSize = JSON.stringify(dataToSend).length / 1024;
      console.log(`Submitting exam data, size: ${payloadSize.toFixed(2)} KB`);

      const response = await submitExamData(dataToSend);

      if (response.error) {
        toast.error(response.error);
      } else {
        setExamId(response.data._id);
        
        // After successful EMR save, mark the appointment as "Complete"
        try {
          const statusResponse = await axios.put(
            `${getApiBaseUrl()}/api/appointments`,
            {
              meetingId: meetingid,
              ID: patientid,
            }
          );
          if (statusResponse.data.success) {
            console.log("Appointment status updated to 'Complete' in EMR save.");
          }
        } catch (statusError) {
          console.error("Error updating appointment status to Complete:", statusError);
          // We don't block the user if status update fails, as the EMR data is already saved
        }

        toast.success("Exam data saved successfully and appointment completed!");
        localStorage.removeItem("patientEMR");
        localStorage.removeItem("emrBedSideData");
        localStorage.removeItem("emrTelestrokeExam");
        setTrackingSessions([]);
      }
    } catch (error) {
      console.error("Error submitting exam data:", error);
      toast.error("There was an error saving the data. Please try again.");
    }
  };

  useEffect(() => {
    if (skipNextWebhookRef.current) {
      console.log("Skipping videoController-webhook on stimulus completion reset");
      skipNextWebhookRef.current = false;
      return;
    }

    console.log("Sending settings to server:", settings);
    axios
      .post(
        `${getApiBaseUrl()}/videoController-webhook`,
        settings
      )
      .then((response) => {
        console.log("Command sent:", response.data);
      })
      .catch((error) => {
        console.error("Error sending command:", error);
        toast.error("There was an error sending the command!");
      });
  }, [settings]);

  return (
    <AppShell
      page="PATIENTS"
      dense
      examLayout
      defaultRailOpen={false}
      lockNavigation={meetingJoined}
      title="Live exam"
      subtitle={meetingid ? `Meeting ${patientid || "—"} · ${meetingid}` : "Join a scheduled or instant session."}
      actions={
        meetingJoined ? (
          <button type="button" className="ts-btn ts-btn-primary" onClick={handleSave}>
            Save exam
          </button>
        ) : null
      }
    >
      {meetingid ? (
        <div className="ts-exam-workspace">
          <div className={`ts-exam-grid ${meetingJoined ? "" : "is-prejoin"}`}>
            <div className="ts-panel ts-exam-video">
              <div className="ts-panel-head">
                <h3 className="ts-panel-title">Video</h3>
                <span className="ts-panel-meta">{meetingJoined ? "Live" : "Ready"}</span>
              </div>
              {/* <VIDEOSDK setMeetingJoined={setMeetingJoined} /> */}
              <VideoCall setMeetingJoined={setMeetingJoined}role="doctor"/>
            </div>
            {meetingJoined && (
              <div className="ts-panel ts-exam-charts">
                <div className="ts-panel-head">
                  <h3 className="ts-panel-title">Eye tracking</h3>
                  <span className="ts-panel-meta">{isPaused ? "Paused" : "Real-time"}</span>
                </div>
                <div className="ts-exam-charts-body">
                        {!isPaused ? (
                          <div className="ts-exam-chart">
                            <h4 className="ts-exam-chart-title">
                              Horizontal Eye Coordinates and Stimulus (X)
                            </h4>
                            <Line
                              ref={chartRef}
                              data={{
                                labels: chartData.labels,
                                datasets: [
                                  chartData.datasets[0],
                                  chartData.datasets[1],
                                ],
                              }}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                animation: { duration: 0 },
                                hover: { animationDuration: 0 },
                                responsiveAnimationDuration: 0,
                                layout: { padding: { top: 2, bottom: 6 } },
                                plugins: {
                                  legend: {
                                    display: true,
                                    position: "top",
                                    labels: {
                                      color: "#000",
                                      boxWidth: 8,
                                      padding: 4,
                                      font: {
                                        weight: 'bold',
                                        size: 10
                                      }
                                    },
                                  },
                                },
                                scales: {
                                  x: {
                                    grid: {
                                      color: "rgba(0, 0, 0, 0.1)",
                                      drawBorder: true,
                                    },
                                    title: {
                                      display: true,
                                      text: "Time (s)",
                                      padding: { top: 0, bottom: 2 },
                                      font: { weight: 'bold', size: 10 }
                                    },
                                    ticks: {
                                      font: { weight: 'bold' },
                                      callback: function (val) {
                                        const raw = typeof this.getLabelForValue === "function" ? this.getLabelForValue(val) : val;
                                        const num = parseFloat(raw);
                                        return !isNaN(num) ? num.toFixed(2) : raw;
                                      }
                                    }
                                  },
                                  y: {
                                    grid: {
                                      color: "rgba(0, 0, 0, 0.1)",
                                      drawBorder: true,
                                    },
                                    min: -70,
                                    max: 70,
                                    title: {
                                      display: true,
                                      text: "Position (X)",
                                      font: { weight: 'bold', size: 10 }
                                    },
                                    ticks: {
                                      font: { weight: 'bold' }
                                    }
                                  },
                                },
                              }}
                            />
                          </div>
                        ) : (
                          <div className="ts-exam-chart ts-exam-chart-paused">
                            <h4 className="ts-exam-chart-title">Chart paused</h4>
                            <p className="ts-muted">Resume to view real-time data</p>
                          </div>
                        )}

                        {!isPaused ? (
                          <div className="ts-exam-chart">
                            <h4 className="ts-exam-chart-title">
                              Vertical Eye Coordinates and Stimulus (Y)
                            </h4>
                            <Line
                              ref={chartRef}
                              data={{
                                labels: chartData.labels,
                                datasets: [
                                  chartData.datasets[2],
                                  chartData.datasets[3],
                                ],
                              }}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                animation: { duration: 0 },
                                hover: { animationDuration: 0 },
                                responsiveAnimationDuration: 0,
                                layout: { padding: { top: 2, bottom: 6 } },
                                plugins: {
                                  legend: {
                                    display: true,
                                    position: "top",
                                    labels: {
                                      color: "#000",
                                      boxWidth: 8,
                                      padding: 4,
                                      font: {
                                        weight: 'bold',
                                        size: 10
                                      }
                                    },
                                  },
                                },
                                scales: {
                                  x: {
                                    grid: {            
                                      color: "rgba(0, 0, 0, 0.1)",
                                      drawBorder: true,
                                    },
                                    title: {
                                      display: true,
                                      text: "Time (s)",
                                      padding: { top: 0, bottom: 2 },
                                      font: { weight: 'bold', size: 10 }
                                    },
                                    ticks: {
                                      font: { weight: 'bold' },
                                      callback: function (val) {
                                        const raw = typeof this.getLabelForValue === "function" ? this.getLabelForValue(val) : val;
                                        const num = parseFloat(raw);
                                        return !isNaN(num) ? num.toFixed(2) : raw;
                                      }
                                    }
                                  },
                                  y: {
                                    grid: {
                                      color: "rgba(0, 0, 0, 0.1)",
                                      drawBorder: true,
                                    },
                                    min: -40,
                                    max: 40,
                                    title: {
                                      display: true,
                                      text: "Position (Y)",
                                      font: { weight: 'bold', size: 10 }
                                    },
                                    ticks: {
                                      font: { weight: 'bold' }
                                    }
                                  },
                                },
                              }}
                            />
                          </div>
                        ) : (
                          <div className="ts-exam-chart ts-exam-chart-paused">
                            <h4 className="ts-exam-chart-title">Chart paused</h4>
                            <p className="ts-muted">Resume to view real-time data</p>
                          </div>
                        )}
                </div>
              </div>
            )}
            {meetingJoined && (
              <div className="ts-panel ts-exam-side">
                <div className="ts-panel-head">
                  <h3 className="ts-panel-title">Controls</h3>
                  <span className="ts-panel-meta">Camera</span>
                </div>
                <div className="ts-exam-side-body custom-scrollbar">
                        <div className="ts-exam-inline-field ts-exam-inline-field-stack">
                          <label>Eye camera</label>
                          <div className="ts-exam-field-box ts-exam-radio-row">
                            <label
                              className="ts-exam-radio"
                              style={
                                isEyeLocked && selectedEye !== "left"
                                  ? { opacity: 0.5, cursor: "not-allowed" }
                                  : undefined
                              }
                              onClick={(e) => {
                                if (isEyeLocked && selectedEye !== "left") {
                                  e.preventDefault();
                                  handleEyeSelect("left");
                                }
                              }}
                            >
                              <input
                                type="radio"
                                id="left"
                                name="eye"
                                value="left"
                                checked={selectedEye === "left"}
                                onChange={() => handleEyeSelect("left")}
                              />
                              Left
                            </label>
                            <label
                              className="ts-exam-radio"
                              style={
                                isEyeLocked && selectedEye !== "right"
                                  ? { opacity: 0.5, cursor: "not-allowed" }
                                  : undefined
                              }
                              onClick={(e) => {
                                if (isEyeLocked && selectedEye !== "right") {
                                  e.preventDefault();
                                  handleEyeSelect("right");
                                }
                              }}
                            >
                              <input
                                type="radio"
                                id="right"
                                name="eye"
                                value="right"
                                checked={selectedEye === "right"}
                                onChange={() => handleEyeSelect("right")}
                              />
                              Right
                            </label>
                          </div>
                        </div>
                        <div className="flex flex-col gap-2">
                          <button
                            type="button"
                            className="ts-btn ts-btn-primary"
                            disabled={
                              !selectedEye || calibrateCounts[selectedEye] >= 2
                            }
                            onClick={handleCalibrate}
                          >
                            Calibrate (
                            {selectedEye
                              ? `${calibrateCounts[selectedEye]}/2`
                              : "0/2"}
                            )
                          </button>
                          {isEyeLocked && (
                            <button
                              type="button"
                              className="ts-btn ts-btn-danger"
                              onClick={handleResetCalibration}
                            >
                              Reset Calibration
                            </button>
                          )}
                        </div>
                        {selectedEye && (
                          <>
                            <div className="ts-exam-inline-field ts-exam-inline-field-stack">
                              <label>Exam Mode</label>
                              <div className="ts-exam-field-box ts-exam-radio-row">
                                <label className="ts-exam-radio">
                                  <input
                                    onChange={() => handleExamModeChange("CenterFocus")}
                                    type="radio"
                                    id="centerFocus"
                                    name="examMode"
                                    value="centerFocus"
                                    checked={centerFocus === true}
                                  />
                                  Center Focus
                                </label>
                                <label className="ts-exam-radio">
                                  <input
                                    onChange={() => handleExamModeChange("Quadrant")}
                                    type="radio"
                                    id="quadrant"
                                    name="examMode"
                                    value="quadrant"
                                    checked={centerFocus === false}
                                  />
                                  Quadrant
                                </label>
                              </div>
                            </div>

                            {centerFocus ? (
                              <StimulusVideoController
                                settings={settings}
                                updateSetting={updateSetting}
                                isPaused={isPaused}
                                setIsPaused={setIsPaused}
                                togglePause={togglePause}
                              />
                            ) : (
                              <QuadrantTracking
                                settings={settings}
                                updateSetting={updateSetting}
                              />
                            )}
                          </>
                        )}
                </div>
              </div>
            )}
          </div>

          {meetingJoined && (
            <div className="ts-panel ts-exam-forms">
              <div className="ts-exam-tabs">
                <button
                  type="button"
                  className={tab === 0 ? "is-active" : ""}
                  onClick={() => setTab(0)}
                >
                  Patient Info
                </button>
                <button
                  type="button"
                  className={tab === 1 ? "is-active" : ""}
                  onClick={() => setTab(1)}
                >
                  Bedside Exam
                </button>
                <button
                  type="button"
                  className={tab === 2 ? "is-active" : ""}
                  onClick={() => setTab(2)}
                >
                  Telestroke Exam
                </button>
              </div>
              <div className="ts-exam-form-body">
                <div className={tab === 0 ? "block" : "hidden"}>
                  <EMRPatientInfo />
                </div>
                <div className={tab === 1 ? "block" : "hidden"}>
                  <EMRBedSide />
                </div>
                <div className={tab === 2 ? "block" : "hidden"}>
                  <EMRTelestrokeExam />
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="ts-panel">
          <div className="ts-exam-join">
            <h3>No meeting selected</h3>
            <p>Open Join from appointments or create an instant meeting first.</p>
          </div>
        </div>
      )}
    </AppShell>
  );
};

export default EMRpage;
